import { combineReducers } from 'redux'
import { ContactsReducer } from './contacts'
import { EmailsReducer } from './emails'
import { InboxReducer } from './inbox'
import labels from './labels'
import portalSummary from './portalSummary'
import portalUsers from './portalUsers'
import { SmsReducer } from './smsMessages'

export default combineReducers({
  portalUsers: portalUsers,
  portalSummary: portalSummary,
  emails: EmailsReducer,
  labels: labels,
  contacts: ContactsReducer,
  smsMessages: SmsReducer,
  inbox: InboxReducer,
})
